export default __webpack_public_path__ + "static/media/moneyTrash.194229a8.svg";